import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { Network } from '@capacitor/network';

export const platform = Capacitor.getPlatform();
export const isWeb = platform === 'web';
export const isAndroid = platform === 'android';
export const isIOS = platform === 'ios';
export const isNative = Capacitor.isNativePlatform();

export async function addHardwareBackListener(callback) {
  if (!isAndroid) return null;
  return CapacitorApp.addListener('backButton', callback);
}

export async function exitNativeApp() {
  if (isAndroid) await CapacitorApp.exitApp();
}

async function browserReachability() {
  if (typeof window === 'undefined') return { connected: true, connectionType: 'unknown' };
  if (!navigator.onLine) return { connected: false, connectionType: 'none' };
  // navigator.onLine is only a hint. Verify reachability with a lightweight
  // request when possible, but never make connectivity itself block the UI.
  try {
    const url = import.meta.env.VITE_SUPABASE_URL;
    if (!url) return { connected: true, connectionType: 'unknown' };
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 4000);
    await fetch(`${url.replace(/\/$/, '')}/rest/v1/`, { method: 'HEAD', cache: 'no-store', signal: controller.signal });
    window.clearTimeout(timer);
    return { connected: true, connectionType: 'internet' };
  } catch {
    return { connected: false, connectionType: 'unreachable' };
  }
}

export async function getNetworkStatus() {
  if (isNative) return Network.getStatus();
  return browserReachability();
}

export async function addNetworkStatusListener(callback) {
  if (isNative) return Network.addListener('networkStatusChange', callback);
  if (typeof window === 'undefined') return null;
  const onOnline = async () => callback(await browserReachability());
  const onOffline = () => callback({ connected: false, connectionType: 'none' });
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);
  return { remove: async () => { window.removeEventListener('online', onOnline); window.removeEventListener('offline', onOffline); } };
}
